import { render, staticRenderFns } from "./project_structure_info.vue?vue&type=template&id=743f0336&scoped=true"
import script from "./project_structure_info.vue?vue&type=script&lang=js"
export * from "./project_structure_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743f0336",
  null
  
)

export default component.exports